export class N2PdfViewerModel {
  public constructor(
    public fileName?: string,
    public file?: Blob,
    public generateXls = false
  ) {}
}
